/** @readonly v2-mapped feature module routes */
export const FEATURE_ROUTES = Object.freeze({
  INTERVENE: '/r/v2/intervene',
  WHATSAPP_TEMPLATES_BASE: '/r/v2/whatsapp-templates',
  WHATSAPP_TEMPLATES: '/r/v2/whatsapp-templates/template-list',
  WHATSAPP_TEMPLATES_CREATE: '/r/v2/whatsapp-templates/create-template',
  WHATSAPP_TEMPLATES_EDIT: '/r/v2/whatsapp-templates/edit-template',
  WHATSAPP_TEMPLATES_DETAILS: '/r/v2/whatsapp-templates/template-details',
  WHATSAPP_TEMPLATES_USERS: '/r/v2/whatsapp-templates/template-users',
  WHATSAPP_TEMPLATE_QUEUE: '/r/v2/whatsapp-templates/template-queue',
  WHATSAPP_OPTIN: '/r/v2/whatsapp-templates/template-list?view=optin',
  WHATSAPP_WABA_APPS: '/r/v2/whatsapp-templates/manager/app-list',
  WHATSAPP_WABA_DETAILS: '/r/v2/whatsapp-templates/manager/app-details',
  WHATSAPP_META_SIGNUP: '/r/setting/meta-embedded-signup',
  FLOW_LIST: '/r/flow/list',
  FLOW_BUILDER: '/r/flow/builder',
  FLOW_SCHEDULE: '/r/flow/schedule-messages',
  SMS_LIST: '/r/sms/list',
  SMS_SEND: '/r/sms/send',
  SMS_CREATE: '/r/sms/create',
  SMS_EDIT: '/r/sms/edit',
  SMS_LOGS: '/r/sms/logs',
  DATASETS: '/r/datasets',
  LEAD_WEB_FORM: '/r/lead-web-form/',
  OPS_VERIFY: '/r/ops-verify/',
  ANALYTICS: '/r/v2/analytics',
  ANALYTICS_BUILDER: '/r/v2/analytics/builder',
  ANALYTICS_BUILDER_EDIT: '/r/v2/analytics/builder/:reportId',
  ANALYTICS_REPORT: '/r/v2/analytics/reports/:reportId',
  // ANALYTICS_TEMPLATE_INSIGHTS: '/r/v2/analytics/template-insights/:templateId',
  // ANALYTICS_TEMPLATE_INSIGHTS_BASE: '/r/v2/analytics/template-insights',
});
